import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {SquareButton} from "@/scenes.ui/square-button";
import {Creature} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {ImageButton} from "@/scenes.ui/image-button";
import {PurchaseItemPanel} from "@/scenes.ui/purchase-item-panel";
import {CreatureToToken, ItemType, PurchaseItem} from "@/store/shop/types";
import Text = Phaser.GameObjects.Text;
import {Tr} from "@/i18n/i18n";

export class HeroTokenPanel extends Phaser.GameObjects.Container {

    public static readonly HEIGHT = 190;
    protected buyButton!: SquareButton;

    constructor(scene: Phaser.Scene, x: number, y: number, ctt: CreatureToToken, c: Creature, callback: () => void) {
        super(scene);

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.width = CU.CANVAS_WIDTH;
        this.height = HeroTokenPanel.HEIGHT;

        let tokenCount = ctt.price;

        const back = SpriteUtils.addImage(this.scene, 0, 0, this.getBackAtlas(c.identifier), this.getBackKey(c.identifier)).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.getHeight(c.identifier) * CU.S);
        this.add(back);

        let stand = SpriteUtils.addSprite(this.scene, 68, 116, Keys.ATLAS_OBLIVION, 'stand_4');
        SpriteUtils.scale(stand, 0.85, 0.85);
        this.add(stand);
        let creaturePanel = new CreaturePanel(scene, 70, 100, c, () => {}, false);
        creaturePanel.setAlpha(1);
        SpriteUtils.scale(creaturePanel, 0.85 / CU.S, 0.85 / CU.S);
        this.add(creaturePanel);

        const rightButton = new ImageButton(this.scene, 172, 104, Keys.ATLAS_OBLIVION, 'arrows');
        this.add(rightButton);

        let pi = new PurchaseItem();
        pi.itemType = ItemType.TOKEN;
        pi.count = tokenCount;
        let pit = new PurchaseItemPanel(scene, 255, 152, 'pack_21', pi, () => {});
        SpriteUtils.scale(pit, 0.85, 0.85);
        this.add(pit)

        this.buyButton = SpriteUtils.scale(new SquareButton(this.scene, 530, this.getBuyButtonPos(c.identifier), 0, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('2.exch'), false, 84 * CU.S, 84 * CU.S, 0), 0.7 / CU.S);

        this.setBuyCallback(this.buyButton, callback);

        const separator = SpriteUtils.addSprite(this.scene!, 0, this.getHeight(c.identifier) + 3, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0, 1);

        this.add([this.buyButton, separator]);

        const titleLight = SpriteUtils.addImage(this.scene, 100, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_LIGHT).setOrigin(0, 0);
        SpriteUtils.setDispSize(titleLight, 300 * CU.S, 65 * CU.S);

        let titleText = TextUtils.addTextAdvanced(scene, ctt.title, 125, 35,
            '#fbd777', 19, 'normal', 450, 'left', 2, Fonts.BENGALY_NORMAL);
        titleText.setStroke('#8c4f19', 5);

        this.add([titleLight, titleText]);

        let desc = TextUtils.addTextAdvanced(this.scene, ctt.desc,
            125, 45, '#efefef', 12, 'normal', 400,
            'left', 2, Fonts.MYRIADPRO_REGULAR)
            .setOrigin(0, 0);
        this.setDescStroke(desc);
        this.add(desc);
    }

    protected setBuyCallback(buyButton: SquareButton, callback: () => unknown): void {
        buyButton.setCallback(() => {
            callback();
        });
    }

    protected getBackAtlas(heroId: string) {
        return heroId === 'sur_ns' ? 'pack_17' : 'pack_8';
    }

    protected getBackKey(heroId: string) {
        return undefined;
    }

    protected getHeight(heroId: string): number {
        return 190;
    }


    protected getBuyButtonPos(decorationId: string) {
        return this.getHeight(decorationId) / 2 - 4;
    }

    protected setDescStroke(desc: Text) {
        desc.setStroke('#2a2a2a', 4);
    }
}
